import PptxGenJS from 'pptxgenjs';
import { defaultViewPortPadding, presentationDimensions } from '@app/services/export/ppt/variables/constants';

export const numCols = 12;
const availableGridWidth = presentationDimensions.w - defaultViewPortPadding.horizontal * 2;
export const singleColWidth = availableGridWidth / numCols;

export const gridCol = (start: number, span: number): { x: number; w: number } => ({
	x: gridColX(start),
	w: gridColWidth(span)
});

export const gridColX = (column: number): number => {
	const leftOffset = defaultViewPortPadding.horizontal;
	return column === 0 ? leftOffset : leftOffset + column * singleColWidth;
};

export const gridColWidth = (span: number): number => span * singleColWidth;

export const createDebugGridForSlide = (slide: PptxGenJS.Slide): void => {
	for (let i = 0; i <= numCols; i++) {
		slide.addShape('line', {
			line: { color: '#F00202', width: 1 },
			y: 0,
			x: gridColX(i),
			w: 0,
			h: presentationDimensions.h
		});
	}
};
